
// Google Analytics 4 integration
// Replace 'G-XXXXXXXXXX' with your actual Google Analytics 4 Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';

/**
 * Initialize Google Analytics
 */
export const initializeGA = (): void => {
  if (typeof window !== 'undefined') {
    // Add Google Analytics script to the document
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
    
    // Initialize the dataLayer and gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    
    // Initialize gtag with your Measurement ID
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
    
    console.log('Google Analytics initialized');
  }
};

/**
 * Track a specific page view
 * @param path The path to track
 * @param title Optional page title
 */
export const trackGAPageView = (path: string, title?: string): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href
    });
  }
};

/**
 * Track a custom event
 * @param eventName The name of the event
 * @param eventParams Optional event parameters
 */
export const trackGAEvent = (
  eventName: string,
  eventParams?: Record<string, any>
): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
